
import { Component, Prop, Vue } from "vue-property-decorator";
import NodeType from "../../types/NodeType";
import ChevronRight from "./ChevronRight.vue";
import ChevronDown from "./ChevronDown.vue";

@Component({
  components: {
    ChevronRight,
    ChevronDown,
  },
})
export default class NodeToggle extends Vue {
  // exclamation means that it is required, which means it does not need to be
  // initialized with a constructor
  @Prop({ required: true }) node!: NodeType;

  get someChildrenVisible(): boolean {
    return this.node.children.some((child) => child.show);
  }

  toggleChildren() {
    this.node.showChildren = !this.node.showChildren;
  }
}
